/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * 0 = UNKNOWN
 * 1001 = INVALID_FILE_FORMAT
 * 2001 = YT_NOT_AVAILABLE
 * 2002 = INSTAGRAM_NOT_AVAILABLE
 * 2003 = TIKTOK_NOT_AVAILABLE
 * 3001 = NO_NOTES_FOUND
 * 3002 = NO_BEATS_FOUND
 * 4001 = ABORTED_BY_ADMIN
 */
export enum ErrorCodes {
  '_0' = 0,
  '_1001' = 1001,
  '_2001' = 2001,
  '_2002' = 2002,
  '_2003' = 2003,
  '_3001' = 3001,
  '_3002' = 3002,
  '_4001' = 4001,
}
